import React from 'react';

const ConfirmedBooking = () => {
  return (
    <div className='comfirm container'>
      <div>
        <h1>Thank you for your reservation!</h1>
        <p>Your reservation is confirmed!</p>
       
      </div>
    </div>
  );
};

export default ConfirmedBooking;